import { Injectable         } from "@angular/core";
import { Observable         } from "rxjs";
import { ApiResponseModel   ,
         HttpApiService     } from "nv@services/http.service";
import { ReportRequest      } from "nv@models/report.model";

@Injectable({
  providedIn: 'root'
})
export class ReportApi extends HttpApiService {

  /**
   * @author Mihail Petrov
   * @param $reportRequest
   * @returns
   */
  public getReportForEntity($reportRequest: ReportRequest): Observable<ApiResponseModel>  {

    return this.forEndpoint(`application`, `reports`)
                .withBody($reportRequest)
                .post();
  }

  /**
   * @author Mihail Petrov
   * @param $id
   * @returns
   */
  public getSummaryReport($id: string) {
    return this.getReportForEntity({ entityId: $id, reportType: 'summary'});
  }

  /**
   * @author Mihail Petrov
   * @param $id
   * @returns
   */
  public getSiteReport($id: string) {
    return this.getReportForEntity({ entityId: $id, reportType: 'site' });
  }



  /**
   * @author Mihail Petrov
   * @param $reportRequest
   * @returns
   */
  public getExcelReport($excelBody: any): Observable<any>  {

    return this.forEndpoint(`roi`, `roi_tables`)
                .withBody($excelBody)
                .parseAsBlob()
                .post();
  }

  /**
   * Upload an Excel file to generate a report from provided data
   * @param $formData FormData containing the Excel file
   * @returns Observable with full HttpResponse including headers
   */
  public generateReportFromExcel($formData: FormData): Observable<any> {

    return this.forEndpoint(`application`, `reports`, `generate-from-excel`)
                .withBody($formData)
                .parseAsBlob()
                .withFullResponse()
                .create();
  }
}
